import PageContainer from "../components/PageContainer";
import PageHeader from "../atom/PageHeader";
import PageContent from "../atom/PageContent";
import LuckyNumberPromoList from "../components/LuckyNumberPromoList";

const Campaigns = () => {
  return (
    <PageContainer pageTitle={"Campanhas | "+ process.env.REACT_APP_SITE_NAME}>
      <PageHeader>
        Campanhas
      </PageHeader>
      <PageContent>
        <div className="contentArea full">
          <LuckyNumberPromoList /> 
        </div>
      </PageContent>
    </PageContainer>
  );
};

export default Campaigns;